$(document).ready(function(){
  if($(window).width()>768){
  $(".footer-block.grid__item.order5, .footer-block.grid__item.order6").wrapAll("<div class='footer_wrapped'></div>");
  $(".footer-block.grid__item.order1, .footer-block.grid__item.order2").wrapAll("<div class='footer_wrapped'></div>");
  }
});

if (window.location.pathname.includes('collection')) {
  // reviewStar();
  document.querySelectorAll('.product-faq-sub-container .questions_wrapper').forEach(ele => {
    ele.addEventListener('click', () => {
      document.querySelectorAll('.product-faq-sub-container .questions_wrapper').forEach(item => {
        item.removeAttribute('open');
      });
        setTimeout(function(){
          ele.setAttribute('open', 'true');
        }, 10);
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  if(window.location.pathname.includes('/product')){
  let pdp_review = document.querySelector(".jdgm-widget .jdgm-prev-badge");
  let descriptions = document.querySelector(".product__description");
  let pro_title = document.querySelector("div.product__title:not(.product__tilte-mobile)");
  let pro_text = document.querySelector("p.product__text.inline-richtext.small-element-10.small-hide");
    let descriptionHeight = descriptions.getBoundingClientRect().height;
    let titleHeight = pro_title.getBoundingClientRect().height;
    let txtHeight = pro_text.getBoundingClientRect().height;
  if(txtHeight != 0){
    txtHeight = txtHeight + 18;
  }
    if(pdp_review){ pdp_review.style.top = `${descriptionHeight + titleHeight + txtHeight + 63}px`; }
  }
});



// for the blog/article header
let features = document.querySelectorAll('.main-cstm-blog');
document.querySelectorAll(".main-cstm-blog .main-features").forEach((featurename, index) => {
  featurename.addEventListener('click', () => {
    features[index].classList.toggle('allFeatures');
  });
});

// for home page pdp card
  
var btn =  document.querySelectorAll('.product-cards-scroll-section .sec-btn');
btn.forEach((btns) => {
  btns.addEventListener('click', function() {
    var pdp_card = this.closest('.product-cards-scroll-section').querySelector('.slick-slide.slick-current.slick-active.slick-center .scroll-product-card a');
    window.location = pdp_card.href;
});
});

$(document).ready(function(){
$(".products-card-slider").slick({
   dots: false,
  arrows: false,
  infinite: true, 
  speed: 900,
  slidesToShow: 4,
  slidesToScroll: 2,
  draggable: true,
  swipeToSlide: true,
  // autoplay:true,
  responsive: [
    {
      breakpoint: 989,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 750,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
      }
    }
  ]
  });
  });

// Engraving Issue in case when properties are blank but still the engrave colour varient is selected.
if(window.location.href.includes('/cart')){
  setTimeout(function(){
    var lineProperty = document.querySelectorAll('#main-cart-items cart-remove-button');
    lineProperty.forEach(item => {
      var property = item.getAttribute('data-hasProperties');
      var engraveOnly = item.getAttribute('data-variantTitle').includes('Engrave');     
      if(property < 2 && engraveOnly){
          item.click()
        }
    });
  },1000);
}
 // setInterval( function(){
 //  if (window.location.pathname.includes('superpods-concerto-earbuds') && 
 //    new URLSearchParams(window.location.search).get('variant') != '48774413386005'){
   
 //      // if(document.querySelector("[data-stock='0']").dataset.stock > 0){
 //      document.querySelector('.mobile-add-to-cart-sticky-button button').innerHTML = 'Pre-Book Now';
 //      document.querySelectorAll('.cstm_pixel__atcButton span').forEach((cstmText) => {
 //          console.log('cstmText',document.querySelector("[data-stock='0']").dataset.stock)
 //          cstmText.innerHTML = 'PRE-BOOK NOW';
 //      });
 //      // }
 //    }
   //    if($(window).width() < 768){
   //     if(window.location.pathname == '/cart'){
   //      const topPrice = document.querySelector('.dynamic_total_price');
   //     const bottomPrice = document.querySelector('.cart__footer__details.large-up-hide .cart__total--price');
   //      if (!document.querySelector('.dynamic_total_price')) {
   //          bottomPrice.innerHTML = 0;
   //      }
   //    bottomPrice.innerHTML = topPrice.innerHTML;
   //    }
   // }
    // }, 500);

// pixel event

document.addEventListener("DOMContentLoaded", function () {
    function getUrlParameter(name) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(name);
    }
    var click_id = getUrlParameter('clickid');
    if (click_id) {
        localStorage.setItem('click_id', click_id);
    }
    function handlePixelFire(goalName) {
        var savedClickId = localStorage.getItem('click_id');
        if (savedClickId) {
            let url = `https://utils.follow.whistle.mobi/pixel.php?linkid=${savedClickId}&goal_name=${goalName}`;
            fetch(url, { method: "GET", mode: "no-cors" })
                .then(() => console.log(`${goalName} Pixel Fired:`, url))
                .catch(err => console.error("Error:", err));
        } else {
            console.error("Error: Click ID not found in local storage.");
        }
    }
    let atcButton = document.querySelector(".cstm_pixel__atcButton");
    if (atcButton) {
        atcButton.addEventListener("click", function () {
            handlePixelFire('Add_to_cart');
        });
    } else {
        console.error("Error: Add to Cart button not found.");
    }
});
//be know the first page

document.addEventListener("DOMContentLoaded", function () {
  const sticky_btns = document.querySelectorAll(".be-the-first-sticky-btn");
  const form_container = document.querySelector(".be-the-first-to-know-form-main-container");
  const cancel_btn = document.querySelector(".be-the-first-to-know-cancle-btn"); 
  
  if (sticky_btns.length && form_container && cancel_btn) {
    sticky_btns.forEach((btn) => {
      btn.addEventListener("click", () => {
        form_container.style.display = "block";
        document.body.style.overflow = "hidden";
      });
    });

    cancel_btn.addEventListener("click", () => {
      form_container.style.display = "none";
      document.body.style.overflow = "";
    });
  } else {
    console.log("Some elements are missing in the DOM.");
  }
});


document.addEventListener("DOMContentLoaded", function () {
  const stickyBtnBottom = document.querySelector('.be-the-first-to-show-sticky-button-wrapper');
  const containerVideo = document.querySelector(".mivi-conversation-q-content-with-img-wrapper");
  var bottom_btn = document.querySelector('.development-journey-container');
 
  if (!stickyBtnBottom || !containerVideo) return;
 
  window.addEventListener('scroll', () => {
    const topContainerVideo = containerVideo.getBoundingClientRect().top;
    const total_height_btn_top = stickyBtnBottom.offSetTop;
    var scroll_total = stickyBtnBottom.getBoundingClientRect().top + window.scrollY;
    var vertical_heightBtn = bottom_btn.offsetTop;
 
    if (topContainerVideo < 100) {
      stickyBtnBottom.classList.remove('hidden');
      if(scroll_total > total_height_btn_top){
        stickyBtnBottom.classList.remove('sticky__btn');
      }
      let extraHeight = 600
      if(window.innerWidth  <= 989) extraHeight = 950
      if(window.scrollY > vertical_heightBtn + extraHeight){
        stickyBtnBottom.classList.add('hidden');
      }else if(window.scrollY < vertical_heightBtn + extraHeight){
        stickyBtnBottom.classList.remove('hidden');
      }
    }
    else {
      stickyBtnBottom.classList.add('hidden');
    }
  });
});
